import mixpanel, { Dict } from 'mixpanel-browser';
import BaseTracker from 'trackers/BaseTracker';

class MixpanelTracker extends BaseTracker {
  tracker: typeof mixpanel;

  constructor() {
    super();
    this.tracker = mixpanel;
    this.initialize();
  }

  protected getTracker(): typeof mixpanel {
    return super.getTracker();
  }

  initialize() {
    if (typeof window === 'undefined') {
      return;
    }

    if (!this.initialized) {
      this.tracker.init(process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN || '', {
        debug: process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production',
      });
      this.initialized = true;
    }
  }

  identify(userId: number) {
    this.getTracker().identify(String(userId));
  }

  reset() {
    this.getTracker().reset();
  }

  alias(userId: number) {
    this.getTracker().alias(String(userId));
  }

  setPeople(properties: Dict) {
    this.getTracker().people.set(properties);
  }

  appendPeople(listName: string, value: any) {
    this.getTracker().people.append(listName, value);
  }

  track(event: string, properties?: Dict) {
    if (properties) {
      const props = Object.entries(properties).reduce((acc, [key, value]) => {
        if (typeof value === 'object') {
          return { ...acc, ...value };
        }
        return { ...acc, ...{ [key]: value } };
      }, {});

      this.getTracker().track(event, props as Dict);
    } else {
      this.getTracker().track(event);
    }
  }
}

export default MixpanelTracker;
